var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "callout",
      attrs: { "border-color": _vm.borderColor, "has-toggle": false }
    },
    [
      _c("validation-observer", { ref: "evalutatorFromRef" }, [
        _c("div", { staticClass: "row mt-2 row-container py-4" }, [
          _c("div", { staticClass: "col-md-2 col-12 border-right status" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 d-none d-md-block" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Nombre:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("capitalize")(_vm.value.fullName)) + " "
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-10" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 d-block d-md-none" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Nombre:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(" " + _vm._s(_vm.value.fullName) + " ")
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-2" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Usuario:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(" " + _vm._s(_vm.value.user.name) + " ")
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-2" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Rol:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(" " + _vm._s(_vm.value.role.name) + " ")
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-12 col-md-3" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Tipo de Propuesta:")
                  ]),
                  !_vm.available && !_vm.isEditing
                    ? _c("span", { staticClass: "info" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.value.proposalServiceEvaluatorType) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  !_vm.available && _vm.isEditing
                    ? _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Tipo de Propuesta es requerido.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.proposalTypes,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.proposalServiceEvaluatorType,
                                      callback: function($$v) {
                                        _vm.proposalServiceEvaluatorType = $$v
                                      },
                                      expression: "proposalServiceEvaluatorType"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2273683083
                        )
                      })
                    : _vm._e(),
                  _vm.available && !_vm.isEditing
                    ? _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Tipo de Propuesta es requerido.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.proposalTypes,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value:
                                        _vm.value.proposalServiceEvaluatorType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.value,
                                          "proposalServiceEvaluatorType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "value.proposalServiceEvaluatorType"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2490993498
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-md-3" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Tipo de Proveedor:")
                  ]),
                  !_vm.available && !_vm.isEditing
                    ? _c("span", { staticClass: "info" }, [
                        _vm._v(
                          " " + _vm._s(_vm.value.proposalProviderType) + " "
                        )
                      ])
                    : _vm._e(),
                  !_vm.available && _vm.isEditing
                    ? _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Tipo de Proveedor es requerido.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.providerTypes,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.proposalProviderType,
                                      callback: function($$v) {
                                        _vm.proposalProviderType = $$v
                                      },
                                      expression: "proposalProviderType"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2216097776
                        )
                      })
                    : _vm._e(),
                  _vm.available && !_vm.isEditing
                    ? _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Tipo de Proveedor es requerido.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.providerTypes,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.value.proposalProviderType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.value,
                                          "proposalProviderType",
                                          $$v
                                        )
                                      },
                                      expression: "value.proposalProviderType"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2942936769
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-2 d-flex justify-content-center align-items-start"
                },
                [
                  _vm.isVisibleDeleteButton(_vm.value.academicYearId) &&
                  !_vm.available &&
                  !_vm.isEditing
                    ? _c(
                        "action-button",
                        {
                          staticClass: "outline-danger py-1",
                          attrs: { i: "fa fa-times-circle" },
                          on: {
                            click: function($event) {
                              return _vm.onRemoveHandler(_vm.value, _vm.index)
                            }
                          }
                        },
                        [_vm._v(" Remover ")]
                      )
                    : _vm._e(),
                  _vm.available
                    ? _c(
                        "action-button",
                        {
                          staticClass: "outline-success py-1",
                          attrs: { i: "fa fa-plus" },
                          on: {
                            click: function($event) {
                              return _vm.onAddHandler(_vm.value, _vm.index)
                            }
                          }
                        },
                        [_vm._v(" Añadir ")]
                      )
                    : _vm._e(),
                  _vm.canEdit && !_vm.isEditing && !_vm.available
                    ? _c(
                        "action-button",
                        {
                          staticClass: "outline-success py-1 ml-2 mr-4",
                          attrs: { i: "fa fa-edit" },
                          on: {
                            click: function($event) {
                              return _vm.edit(_vm.value)
                            }
                          }
                        },
                        [_vm._v(" Editar ")]
                      )
                    : _vm._e(),
                  _vm.isEditing && !_vm.available
                    ? _c(
                        "action-button",
                        {
                          staticClass: "outline-danger py-1 mr-2",
                          attrs: { i: "fa fa-times-circle" },
                          on: {
                            click: function($event) {
                              return _vm.cancelEdit()
                            }
                          }
                        },
                        [_vm._v(" Cancelar ")]
                      )
                    : _vm._e(),
                  _vm.isEditing && !_vm.available
                    ? _c(
                        "action-button",
                        {
                          staticClass: "outline-success py-1 mr-4",
                          attrs: { i: "fa fa-save" },
                          on: {
                            click: function($event) {
                              return _vm.onEditHandler(_vm.value, _vm.index)
                            }
                          }
                        },
                        [_vm._v(" Guardar ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }